import { render, staticRenderFns } from "./OrderCardMobile.vue?vue&type=template&id=1930511a&scoped=true&"
import script from "./OrderCardMobile.vue?vue&type=script&lang=ts&"
export * from "./OrderCardMobile.vue?vue&type=script&lang=ts&"
import style0 from "./OrderCardMobile.vue?vue&type=style&index=0&id=1930511a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1930511a",
  null
  
)

export default component.exports